export const onMouseUp = ({
  hotspotType,
  drawing,
  startXY,
  root,
  inverseScale,
  rectState,
  pubSub,
}) => {
  return e => {
    if (hotspotType !== 'rectangle') {
      return;
    }

    drawing.current = false;

    pubSub.publish('UPDATE_HOTSPOT_POINTS', {
      points: rectState.current,
      updateRectangleHotspotLocalState: false,
    });
  };
};
